import { Typography, Box, CircularProgress, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function LoadingPage() {
  const { t } = useTranslation();

  return (
    <Box sx={{ height: "100%", width: "100%", position: "absolute" }}>
      <Stack sx={{ width: "100%", height: "100%" }} alignItems="center" justifyContent="center" spacing={2}>
        <CircularProgress sx={{ width: "64px", height: "64px" }} color="inherit" variant="indeterminate" />
        <Typography variant="body1" textAlign="center" sx={{ paddingLeft: 0.5 }}>{t("common:loadingState")}</Typography>
      </Stack>
    </Box >
  );
}
